<template>
  <div style="padding: 0 16px">
    <a-skeleton :loading="spinning" active avatar>
      <a-table :columns="columns" :pagination="pagination" :data-source="records" size="small" row-key="index" @change="handleTableChange">
        <span slot="number" slot-scope="record">{{ record.index }}</span>
        <span slot="operator" slot-scope="operator">{{ operator ? operator.nickname : '系统' }}</span>
        <span slot="diffItem" slot-scope="record">
          <div v-for="(item, key) in record.value_diff" :key="key">{{ item.label }}</div>
        </span>
        <span slot="before" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="['title', 'handler', 'verifier', 'deadline', 'project_id'].includes(item.value)">{{ item.before ? item.before : '--' }}</div>
              <div v-else-if="item.value === 'serious'">{{ item.before !== null ? issueSerious[item.before].label : '--' }}</div>
              <div v-else-if="item.value === 'chance'">{{ item.before !== null ? issueChances[item.before].label : '--' }}</div>
              <div v-else-if="item.value === 'version'">{{ item.before ? item.before.title : '--' }}</div>
              <div v-else-if="item.value === 'requirement'">{{ item.before ? item.before.title : '--' }}</div>
              <div v-else-if="item.value === 'status'">
                <a-tag v-if="item.before !== null && issueStatus[item.before]" :color="issueStatus[item.before].color">{{ issueStatus[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'priority'">
                <a-tag v-if="item.before !== null" :color="issuePrioritys[item.before].color">{{ issuePrioritys[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'description'">
                <a v-if="item.before !== null" @click="onPreview(item.before, '「变更前」描述')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'issue_type'">
                <a-badge v-if="item.before !== null" :color="issueTypes[item.before].color" :text="issueTypes[item.before].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'point'">{{ item.before !== null ? item.before : '--' }}</div>
              <div v-else>--</div>
            </span>
          </span>
        </span>
        <span slot="after" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="['title', 'handler', 'verifier', 'deadline', 'project_id'].includes(item.value)">{{ item.after ? item.after : '--' }}</div>
              <div v-else-if="item.value === 'serious'">{{ item.after !== null ? issueSerious[item.after].label : '--' }}</div>
              <div v-else-if="item.value === 'chance'">{{ item.after !== null ? issueChances[item.after].label : '--' }}</div>
              <div v-else-if="item.value === 'version'">{{ item.after ? item.after.title : '--' }}</div>
              <div v-else-if="item.value === 'requirement'">{{ item.after ? item.after.title : '--' }}</div>
              <div v-else-if="item.value === 'status'">
                <a-tag v-if="item.after !== null && issueStatus[item.after]" :color="issueStatus[item.after].color">{{ issueStatus[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'priority'">
                <a-tag v-if="item.after !== null" :color="issuePrioritys[item.after].color">{{ issuePrioritys[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'description'">
                <a v-if="item.after !== null" @click="onPreview(item.after, '「变更后」描述')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'issue_type'">
                <a-badge v-if="item.after" :color="issueTypes[item.after].color" :text="issueTypes[item.after].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'point'">{{ item.after !== null ? item.after : '--' }}</div>
              <div v-else>--</div>
            </span>
          </span>
        </span>
      </a-table>
    </a-skeleton>
    <preview-modal ref="previewModal" />
  </div>
</template>

<script>
import { issueRecord } from '@/api/project/issue';
import { issueStatus, issuePrioritys, issueTypes, issueChances, issueSerious } from '@/utils/dictionary';

import PreviewModal from '@/pages/project/components/PreviewModal';

const columns = [
  {
    title: '序号',
    width: '5%',
    align: 'center',
    scopedSlots: { customRender: 'number' }
  },
  {
    title: '操作人',
    width: '10%',
    align: 'center',
    dataIndex: 'operator',
    key: 'operator',
    scopedSlots: { customRender: 'operator' }
  },
  {
    title: '操作时间',
    width: '15%',
    align: 'center',
    key: 'created_time',
    dataIndex: 'created_time'
  },
  {
    title: '变更类型',
    width: '10%',
    align: 'center',
    key: 'operation_alias',
    dataIndex: 'operation_alias'
  },
  {
    title: '变更项',
    width: '10%',
    align: 'center',
    scopedSlots: { customRender: 'diffItem' }
  },
  {
    title: '变更前',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'before' }
  },
  {
    title: '变更后',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'after' }
  }
];
export default {
  components: { PreviewModal },
  props: {
    issueId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      columns,
      issueStatus,
      issuePrioritys,
      issueTypes,
      issueChances,
      issueSerious,
      spinning: true,
      projectId: parseInt(this.$route.params.project_id) || null,
      pagination: {
        size: 'small',
        total: 0,
        pageSize: this.$store.getters.pageSize, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      records: [],
      recordItems: {
        title: { value: 'title', label: '标题' },
        status: { value: 'status', label: '状态' },
        version: { value: 'version', label: '迭代' },
        requirement: { value: 'requirement', label: '需求' },
        chance: { value: 'chance', label: '出现概率' },
        priority: { value: 'priority', label: '优先级' },
        serious: { value: 'serious', label: '严重等级' },
        handler: { value: 'handler', label: '处理人' },
        verifier: { value: 'verifier', label: '验证人' },
        description: { value: 'description', label: '描述' },
        issue_type: { value: 'issue_type', label: '类型' },
        deadline: { value: 'deadline', label: '截止时间' },
        project_id: { value: 'project_id', label: '项目' },
        point: { value: 'point', label: '缺陷点数' }
      }
    };
  },
  computed: {
    diff() {
      return data => {
        const items = [];
        const itemKeys = Object.keys(this.recordItems);
        for (const key in data) {
          if (itemKeys.includes(key)) {
            items.push({
              ...this.recordItems[key],
              ...data[key]
            });
          }
        }
        return items;
      };
    }
  },
  created() {
    if (this.issueId !== null) {
      this.getIssueRecord();
    }
  },
  methods: {
    getIssueRecord() {
      issueRecord({
        issue_id: this.issueId,
        project_id: this.projectId,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.records = res.data.items.map((record, index) => {
            return {
              index: index + 1,
              ...record,
              value_diff: this.diff(record.value_diff)
            };
          });
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
        });
    },

    onPreview(content, title = null) {
      this.$nextTick(() => {
        this.$refs.previewModal.onOpen(content, title);
      });
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getIssueRecord();
    }
  }
};
</script>
<style lang="less" scoped>
.diff-item {
  display: block;
}

.ql-container.ql-snow {
  border: none;
}
</style>
